import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Theme,
  Grid
} from '@material-ui/core';
import { Close, NavigateBefore, NavigateNext } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { FC } from 'react';
import { isNull, isNullOrUndefined } from 'util';
import OrderCard from './OrderCard';
import { DSOrder, StatusBoardType } from './StatusTypeList.stories';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    height: 'calc(100% - 96px)',
    background: 'transparent',
    maxWidth: 1000
  },
  dialogContainer: {
    background: 'rgba(0, 0, 0, 0.9)'
  },
  title: {
    marginRight: 48
  },
  close: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(0)
  },
  navigation: {
    color: 'white',
    width: 50,
    height: 50
  },
  iconButton: {
    padding: 0,
    margin: 0
  },
  dialogContent: {
    display: 'flex'
  }
}));

interface OrderCardDialogProps {
  statusType: StatusBoardType;
  order: DSOrder;
  onStatusChanged?: (order: DSOrder) => void;
  onClose?: () => void;
  onNavigation?: (index: number) => void;
  hasPrevious: boolean;
  hasNext: boolean;
}

const OrderCardDialog: FC<OrderCardDialogProps> = ({
  statusType,
  order,
  onStatusChanged,
  onClose,
  onNavigation,
  hasPrevious,
  hasNext
}: OrderCardDialogProps) => {
  const classes = useStyles();

  const handleClose = () => {
    if (!isNullOrUndefined(onClose)) {
      onClose();
    }
  };

  const handleNavigation = (index: number) => {
    if (!isNullOrUndefined(onNavigation)) {
      onNavigation(index);
    }
  };

  return useObserver(() => {
    if (isNull(order)) {
      return null;
    }
    return (
      <Dialog
        open
        scroll="paper"
        onClose={handleClose}
        classes={{ paper: classes.paper, container: classes.dialogContainer }}
      >
        <DialogTitle disableTypography>
          <IconButton
            aria-label="close"
            className={classes.close}
            onClick={handleClose}
          >
            <Close className={classes.navigation} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <Grid container key="orderGrid" direction="row">
            <IconButton
              aria-label="close"
              className={classes.iconButton}
              onClick={() => handleNavigation(-1)}
              disabled={!hasPrevious}
            >
              <NavigateBefore className={classes.navigation} />
            </IconButton>

            <OrderCard
              statusType={statusType}
              order={order}
              fullView={true}
              onStatusChanged={onStatusChanged}
            />

            <IconButton
              aria-label="close"
              className={classes.iconButton}
              onClick={() => handleNavigation(1)}
              disabled={!hasNext}
            >
              <NavigateNext className={classes.navigation} />
            </IconButton>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  });
};

export default OrderCardDialog;
